import React from 'react';
import './style.scss';
import { InputTemplate, InputTemplateProps } from '../inputTemplate';

export enum UnitInputPosition {
  before = 'unitBefore',
  center = 'unitCenter',
  after = 'unitAfter',
}
export type UnitInputProps = InputTemplateProps & {
  unit: UnitInputPosition;
  label: string;
};

export const UnitInput = (props: UnitInputProps) => {
  const { unit, label, type, value, placeholder, disabled, error, onChange, maxLength, alignment } = props;
  return (
    <>
      <div className="unitInput">
        <div className={`unitInput_unit ${unit}`}>{label}</div>
        <InputTemplate
          type={type}
          value={value}
          placeholder={placeholder}
          disabled={disabled}
          error={error}
          onChange={onChange}
          maxLength={maxLength}
          alignment={alignment}
        />
      </div>
    </>
  );
};
